import { ForwardedRef, RefObject, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import styles from '@features/productPreview/sections/ProductDescription/components/ProductDescriptionBlock/ProductDescriptionItem.styles';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import Heading from '@components/Heading/Heading';
import { WindowType } from '@typescript/index';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
type PropsType = {
  title: string | null;
  children: React.ReactNode;
  windowType: WindowType;
  isExpanded: boolean;
  childrenRef?: ForwardedRef<HTMLDivElement>;
  onClick?: (ref: RefObject<HTMLDivElement | null>, childrenRef: RefObject<HTMLDivElement | null>) => void;
};
const ProductDescriptionItem = ({
  title,
  children,
  windowType,
  isExpanded,
  childrenRef = undefined,
  onClick = undefined
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const divRef = useRef<HTMLDivElement>(null);
  const expandedContentRef = useRef<HTMLDivElement | null>(null);
  return <ErrorBoundary>
      <div ref={divRef} sx={styles.productDescriptionItem}>
        {title && <div sx={styles.headerContainer} onClick={() => onClick?.(divRef, expandedContentRef)} onKeyDown={e => e.key === 'Enter' && onClick?.(divRef, expandedContentRef)} role="button" tabIndex={0}>
            <Button variant="link" cy="CloseButton" fullWidth addSx={styles.addButton}>
              <Heading h={3} headingType={4} addSx={styles.heading}>
                {title}
              </Heading>
              <Icon icon={`${isExpanded ? 'Minus' : 'Add'}`} size={windowType === WindowType.mobile || windowType === WindowType.tablet ? '18px' : '30px'} aria-label={isExpanded ? t('collapse') : t('expand')} title={isExpanded ? t('collapse') : t('expand')} />
            </Button>
          </div>}

        <div sx={styles.productDescriptionItems(isExpanded)} ref={childrenRef}>
          {children}
        </div>
      </div>
    </ErrorBoundary>;
};
export default observer(ProductDescriptionItem);